export const blogPost:Blogpost[] = [
  {
    "id": 1,
    "imageUrl": "/images/group-invoicing-2.jpeg",
    "date_published": "2024-04-19",
    "images": {
      "nl": [{"image_id":1, "source":"/images/blog/blogpost1.nl.png"}, {"image_id":2, "source":"/images/blog/blogpost1.1.nl.png"}],
      "fr": [{"image_id":1, "source":"/images/blog/blogpost1.fr.png"}, {"image_id":2, "source":"/images/blog/blogpost1.1.fr.png"}]
    },
    "category": 1,
    "nl": {
      "title": "E-facturatie (Peppol) vanaf 2026 verplicht in België",
      "subtitle": "Peppol",
      "paragraph": [
        {
          "title": "Wat is e-facturatie?",
          "content": "E-facturatie is meer dan facturen in pdf-formaat versturen per mail. Als we het over e-facturatie of e-invoicing hebben, verwijst dit in de eerste plaats naar gestructureerde elektronische facturen in UBL-formaat volgens de Europese Peppol-standaard. Anders gezegd, de factuur wordt in een specifiek formaat meteen herkend en verwerkt door ERP of boekhoudingsoftware. Het is met andere woorden van belang om jouw huidige software aan te passen waardoor e-facturatie mogelijk wordt.",
          "image_id": 1
        },
        {
          "title": "Waarom e-facturatie?",
          "content": "Op heden is digitaal factureren met Peppol enkel verplicht voor bedrijven die samenwerken met de Federale of Vlaamse Overheid. Vanaf 1 januari 2026 wordt deze verplichting om Peppol als standaard te gebruiken bij e-facturatie verder uitgerold in België. Hiermee volgt België de lijn die door de Europese Commissie werd uitgezet en reeds geïmplementeerd werd door verschillende EU-landen. Deze stap naar digitale facturatie is voor België belangrijk om de zogenaamde BTW-kloof, het verschil tussen wat de overheid moet ontvangen aan btw-inkomsten en wat de overheid daadwerkelijk ontvangt, verder te dichten.",
        },
        {
          "title": "Waaruit bestaat deze administratieve vereenvoudiging?",
          "content": "Door het gebruik van één standaard tussen alle BTW-plichtigen (of ondernemingen en overheden), wordt de verwerking van digitale facturaten vereenvoudigd. Waar op heden heel wat stappen moeten doorlopen worden om de factuur op te maken, te versturen, eventueel opnieuw te digitaliseren en te archiveren, zal Peppol dit proces een stuk rechtlijniger maken. Zo zorgt Peppol voor een snel en veilige digitale uitwisseling van facturen (het zogenaamde Peppol Network). Elke onderneming sluit zich hiervoor aan bij een eigen gekozen Peppol-Access Point. Het Access Point verzorgt daarna de registratie op het Peppol-netwerken en de vlotte communicatie met het Access Point van de ontvangen van de factuur.",
        },
        {
          "title": "Digitalisatie wordt de norm",
          "content": "De keuze voor Peppol betekent meteen ook de keuze voor een volledig gedigitaliseerd facturatieproces. Tijdrovende handelingen zoals het manueel overtypen van facturen wordt volledig verledentijd. De keuze voor een betrouwbare partner die je kan begeleiden bij deze transitie en registreren bij een  Peppol Access Point wordt in die zin cruciaal. Het is van belang om hier niet al te lang mee te wachten en tijdig aan de slag te gaan. Hoewel dit een vrij technisch en complex gegeven is, neemt dit niet weg dat de implementatie en registratie op Peppol vrij vlot kan verlopen. Voor elk type onderneming bestaat een gepaste oplossing binnen elk budget.",
          "image_id": 2
        },
      ]
    },
    "fr": {
      "title": "La facturation électronique (Peppol) obligatoire en Belgique à partir de 2026",
      "subtitle": "Peppol",
      "paragraph": [
        {
          "title": "Qu'est-ce que la facturation électronique ?",
          "content": "La facturation électronique va au-delà de l'envoi de factures au format PDF par e-mail. Lorsque nous parlons de facturation électronique, nous faisons référence en premier lieu à des factures électroniques structurées au format UBL selon la norme européenne Peppol. En d'autres termes, la facture est immédiatement reconnue et traitée par un logiciel ERP ou de comptabilité dans un format spécifique. Il est donc important d'adapter votre logiciel actuel pour permettre la facturation électronique.",
          "image_id": 1
        },
        {
          "title": "Pourquoi la facturation électronique ?",
          "content": "À l'heure actuelle, la facturation électronique avec Peppol n'est obligatoire que pour les entreprises qui collaborent avec le gouvernement fédéral ou flamand. À partir du 1er janvier 2026, cette obligation d'utiliser Peppol comme norme pour la facturation électronique sera étendue en Belgique. Ainsi, la Belgique suit la ligne tracée par la Commission européenne et déjà mise en œuvre par différents pays de l'UE. Cette transition vers la facturation électronique est importante pour la Belgique afin de combler l'écart de TVA, c'est-à-dire la différence entre ce que le gouvernement devrait percevoir en termes de recettes de TVA et ce qu'il perçoit réellement.",
          "image_id": 2
        },
        {
          "title": "En quoi consiste cette simplification administrative ?",
          "content": "En utilisant une norme unique entre tous les assujettis à la TVA (entreprises et administrations publiques), le traitement des factures électroniques est simplifié. Alors qu'actuellement, de nombreuses étapes doivent être franchies pour émettre, envoyer, éventuellement numériser à nouveau et archiver la facture, Peppol rendra ce processus beaucoup plus direct. Ainsi, Peppol permet un échange rapide et sécurisé de factures électroniques (le soi-disant réseau Peppol). Chaque entreprise adhère à un Point d'Accès Peppol choisi. Le Point d'Accès assure ensuite l'inscription sur le réseau Peppol et la communication fluide avec le Point d'Accès du destinataire de la facture."
        },
        {
          "title": "La numérisation devient la norme",
          "content": "Le choix de Peppol signifie également le choix d'un processus de facturation entièrement numérisé. Des tâches chronophages telles que la saisie manuelle des factures appartiennent désormais au passé. Le choix d'un partenaire fiable pour vous accompagner dans cette transition et vous inscrire à un Point d'Accès Peppol est crucial. Il est important de ne pas attendre trop longtemps et de commencer à agir rapidement. Bien que cela soit un sujet technique et complexe, la mise en œuvre et l'inscription à Peppol peuvent se faire assez facilement. Il existe une solution adaptée à chaque type d'entreprise, quel que soit le budget.",
          "image_id": 2
        }
      ]
    }
  }, 
  {
    "id": 2,
    "imageUrl": "/images/blog-writer.jpeg",
    "date_published": "2024-04-29",
    "images": {
      "nl": [{"image_id":1, "source":"https://pbs.twimg.com/media/EE8fxeyUwAARBEy?format=jpg&name=4096x4096"}],
      "fr": [{"image_id":1, "source":"https://pbs.twimg.com/media/EE8fxeyUwAARBEy?format=jpg&name=4096x4096"}]
    },
    "category": 2,
    "nl": {
      "title": "120% fiscale aftrekbaarheid voor PEPPOL e-facturatiesoftware voor kleine vennootschappen.",
      "subtitle": "Ondernemers",
      "paragraph": [
        {
          "content": "Op 1 januari 2026 wordt de verplichting om elektronisch te facturen doorgevoerd in België en dit voor alle bedrijven. Vanaf die dag zal je als ondernemer moeten werken met een XML-factuur die afgeleverd wordt volgens de PEPPOL-afspraken. Het versturen van PDF-facturen wordt dus niet langer toegelaten.",
          "image_id": 1
        },
        {
          "title": "Hoe Peppol versturen en ontvangen?",
          "content": "Bekijk zeker en vast even jouw facturatiepakket of ERP-pakket waarmee je nu factureert. Mocht dit pakket niet de mogelijkheden bieden om Peppol op een investeringsvriendelijke manier op te zetten, kunnen we met Qastan dit zeker en vast in orde brengen."
        },
        {
          "title": "Verhoogde investeringsaftrek?",
          "content": "Om de kosten die verbonden zijn aan het omschakelen van jouw systeem te verminderen, voorziet de fiscus een tijdelijke verhoogde investeringsaftrek van 120%. Specifiek gaat het om volgende kosten:",
        },
        {
          "content": "•	Kosten verbonden aan factureringspakketten zoals periodieke abonnementskosten",
        },
        {
          "content": "•	Advieskosten die specifiek gemaakt worden ter voorbereiding van de omschakeling.",
        },
        {
          "title": "Voor wie is de investeringsaftrek van toepassing?",
          "content": "De verhoogde aftrek is van toepassing op zelfstandigen, vrije beroepen en  kleine vennootschappen. Een kleine vennootschap wordt hierbij gezien als een onderneming met maximaal 11,25 miljoen euro jaaromzet, een jaargemiddelde van maximaal 50 werknemers en een balanstotaal van 6 miljoen euro.",
        },
        {
          "title": "Vanaf wanneer geldt de investeringsaftrek?",
          "content": "Voor alle investeringen (advieskosten en abonnementskosten) is de verhoogde  aftrek van toepassing vanaf 1 januari 2024 en dus geldig voor het aanslagjaar 2025."
        }
      ]
    },
    "fr": {
      "title": "Déductibilité fiscale à 120 % pour le logiciel de facturation électronique PEPPOL destiné aux petites entreprises.",
      "subtitle": "Entrepreneurs",
      "paragraph": [
        {
          "content": "Le 1er janvier 2026, l'obligation de facturer électroniquement sera mise en place en Belgique pour toutes les entreprises. À partir de ce jour, en tant qu'entrepreneur, vous devrez travailler avec une facture XML délivrée conformément aux accords PEPPOL. L'envoi de factures PDF n'est donc plus autorisé.",
          "image_id": 1
        },
        {
          "title": "Comment envoyer et recevoir du Peppol ?",
          "content": "Assurez-vous de jeter un œil à votre package de facturation ou à votre package ERP avec lequel vous facturez actuellement. Si ce paquet n’offre pas la possibilité de créer Peppol de manière favorable aux investissements, nous pouvons certainement organiser cela avec Qastan."
        },
        {
          "title": "Une déduction pour investissement augmentée ?",
          "content": "Pour réduire les coûts liés au changement de système, le fisc accorde une déduction temporaire pour investissement majorée de 120 %. Cela concerne spécifiquement les coûts suivants :",
        },
        {
          "content": "•	Coûts associés aux forfaits de facturation tels que les frais d'abonnement périodiques.",
        },
        {
          "content": "•	Frais de conseil spécifiquement engagés dans la préparation du changement.",
        },
        {
          "title": "À qui s’applique la déduction pour investissement ?",
          "content": "La déduction majorée s'applique aux indépendants, aux professions libérales et aux petites entreprises. Une petite entreprise est considérée comme une entreprise avec un chiffre d'affaires annuel maximum de 11,25 millions d'euros, une moyenne annuelle d'un maximum de 50 salariés et un total de bilan de 6 millions d'euros.",
        },
        {
          "title": "A partir de quand la déduction pour investissement s'applique-t-elle ?",
          "content": "Pour tous les investissements (frais de conseil et frais d'abonnement), la déduction majorée s'applique à compter du 1er janvier 2024 et est donc valable pour l'année fiscale 2025."
        }
      ]
    }
  
  },
  {
    "id": 3,
    "imageUrl": "/images/group-invoicing.jpeg",
    "date_published": "2024-08-06",
    "images": {
      "nl": [{"image_id":1, "source":"/images/blog/blogpost1.nl.png"}, {"image_id":2, "source":"/images/blog/blogpost1.1.nl.png"}],
      "fr": [{"image_id":1, "source":"/images/blog/blogpost1.fr.png"}, {"image_id":2, "source":"/images/blog/blogpost1.1.fr.png"}]
    },
    "category": 1,
    "nl": {
      "title": "Hoe kan Qastan jou bijstaan in het gebruik van PEPPOL?",
      "subtitle": "Peppol",
      "paragraph": [
        {
          "title": "•	Controle",
          "content": "Heb je reeds een bestaand boekhoud- of facturatiepakket? Dan gaan onze experts met veel plezier na jouw pakket PEPPOL-facturatie kan versturen en ontvangen."
        },
        {
          "title": "•	Advies op maat",
          "content": "We bieden advies op maat van elk type onderneming: groot of klein. Zo zorgen we ervoor dat jouw organisatie volledig PEPPOL-proof wordt."
        },
        {
          "title": "•	Implementatie",
          "content": "Nog geen softwarepakket? Of kan het huidige pakket niet voldoen aan de nieuwe PEPPOL-standaarden? Dan bekijken we graag even de mogelijkheden om jouw organisatie alsnog PEPPOL-proof te maken."
        },
        {
          "title": "•	Je maakt je facturen handmatig of in Word/Excel?",
          "content": "Je hebt momenteel nog geen facturatiepakket maar wil toch in orde zijn met de PEPPOL-verplichting. Geen nood. We helpen je snel verder met onze gebruiksvriendelijke oplossing voor kleine ondernemingen en zelfstandigen."
        }
      ]
    },
    "fr": {
      "title": "Comment Qastan peut-il vous aider à utiliser PEPPOL ?",
      "subtitle": "Peppol",
      "paragraph": [
        {
          "title": "•	Vérifier",
          "content": "Vous disposez déjà d'un package de comptabilité ou de facturation existant ? Alors nos experts se feront un plaisir d'envoyer et de recevoir votre package de facturation PEPPOL."
        },
        {
          "title": "•	Conseils sur mesure",
          "content": "Nous proposons des conseils adaptés à chaque type d’entreprise : grande ou petite. C'est ainsi que nous garantissons que votre organisation devient totalement à l'épreuve de PEPPOL."
        },
        {
          "title": "•	Mise en œuvre",
          "content": "Vous n'avez pas encore de logiciel ? Ou le package actuel ne peut-il pas répondre aux nouvelles normes PEPPOL ? Nous aimerions ensuite examiner les options permettant de rendre votre organisation à l'épreuve du PEPPOL."
        },
        {
          "title": "•	Créez-vous vos factures manuellement ou dans Word/Excel ?",
          "content": "Vous ne disposez pas encore de forfait de facturation pour l'instant, mais vous souhaitez tout de même respecter l'obligation PEPPOL. Pas de soucis. Nous vous aiderons rapidement grâce à notre solution conviviale pour les petites entreprises et les travailleurs indépendants."
        }
      ]
    }
  }
]

export const categories:Category[] = [
  {
    category_id: 0,
    nl: {
      title: "Accountants en boekhouding",
      description: ""
    },
    fr: {
      title: "Comptables et tenue de livres",
      description: ""
    }
  },
  {
    category_id: 1,
    nl: {
      title: "Peppol",
      description: ""
    },
    fr: {
      title: "Peppol",
      description: ""
    }
  },
  {
    category_id: 2,
    nl: {
      title: "Ondernemers",
      description: ""
    },
    fr: {
      title: "Entrepreneurs",
      description: ""
    }
  }
]